import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const purchaseOrderDetailRolesRBAC = {
  pageID: '2260371467e476b095e9116fb4755add',
  elementID: {
    ButtonPrintQR: '7e8bb58475feef43e3c586659300c099',
    ViewPricing: 'dc7ba83c12122d1019cc47d3c947eb5c',
  },
} as const

export const useRBACPurchaseOrderDetailPage = createUseRBAC(purchaseOrderDetailRolesRBAC.elementID)

export type UseRBACPurchaseOrderDetailPageType = ReturnType<typeof useRBACPurchaseOrderDetailPage>
